
import { Controller, useForm } from "react-hook-form";
import { ClockLoader } from "react-spinners";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/button";
import Input from "../../components/input";
import SideImage from "../../assets/images/sideImage.png";
import AuthLayout from "../../components/layouts/auth-layout";
import { toast } from "sonner";
import useRequest from "../../components/hook/use-req";
import { SmallMailIcon } from "../../assets/icon";

const ForgotPassword = () => {
  const { handleSubmit, control, reset } = useForm();
  const { loading, makeRequest } = useRequest("/auth/forgot-password", "POST");
const navigate = useNavigate()
  const handleForgotPassword = handleSubmit(async (formData) => {
    const user = {
      email: formData.email,
    };
    const [response] = await makeRequest(undefined, user);
    if (response) {
      toast.success(response.message);
     localStorage.setItem("resetEmail", formData.email);
      navigate('/reset-verification')
      reset();
    } else {
      toast.error(response?.message || "An error occurred, please try again");
    }
  });

  return (
    <AuthLayout sideImageSrc={SideImage}>
      <div className="mb-32">
        <h1 className="text-[32px] font-bold text-[#3A3428]">
          Welcome to <span className="font-normal">ConvoHub</span>
        </h1>
        <p className="text-[16px] text-[#434343]">
          Reach customers on every channel, effortlessly.
        </p>
      </div>
      <form onSubmit={handleForgotPassword} className="w-full">
        <h6 className="text-[24px] font-medium text-[#3A3428]">Reset Password</h6>
        <span className="text-[14px] text-[#434343] mt-2 block">
          Enter your registered Email address and we will send you a link to <br /> reset your password
        </span>
        <Controller
          name="email"
          control={control}
          defaultValue=""
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Enter a valid email.",
            },
          }}
          render={({ field, fieldState }) => (
            <Input
              label="Email address"
              icon={<SmallMailIcon />}
              value={field.value}
              placeholder="Enter your email"
              className="w-full mt-4"
              error={fieldState?.error?.message}
              onChange={field.onChange}
              autoComplete="off"
            />
          )}
        />

        <Button
          size="lg"
          variant="primary"
          className="w-full mt-5"
          type="submit"
        >
          {loading ? (
            <ClockLoader color="#ffffff" loading={loading} size={20} />
          ) : (
            "Send Reset Link"
          )}

        </Button>
     <p className="mt-5 text-center text-xs text-gray-500">
                Remember your Password?{" "}
                <Link to="/login" className="text-[#4338CA] underline hover:text-violet-700 font-semibold transition-colors">
                    Sign In
                </Link>
            </p>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
